import { useForm, useStore } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter/FilterWrapper'
import { TableFilterRow } from 'ui/temp/TableFilterRow'

import { useApplicationPipelineReportContext } from '../../context/ApplicationPipelineReportContext'

import * as SC from './styles'

export const Filter = () => {
  const {
    data: {
      form: { status },
      statusOptions
    },
    routeApi
  } = useApplicationPipelineReportContext()

  const navigate = routeApi.useNavigate()
  const formApi = useForm({
    defaultValues: status
  })

  const clearForm = () => {
    formApi.reset()
    navigate({ to: '.', search: undefined, resetScroll: false, replace: true })
  }

  return (
    <FilterPanel expanded={false} isDirty={useStore(formApi.store, (s) => s.isDirty) || false} onReset={clearForm}>
      <FilterWrapper>
        <TableFilterRow>
          <SC.FilterWrapper>
            <SC.ItemWrapper>
              <formApi.Field
                name="status"
                listeners={{
                  onChange: ({ value }) => {
                    // @ts-ignore why value is unknown?
                    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, status: value }) })
                    return undefined
                  }
                }}
                children={(field) => (
                  <FF
                    label="Status"
                    field={field}
                    input={(inputProps) => <Select {...inputProps} data-qa="Active" data={statusOptions} />}
                  />
                )}
              />
            </SC.ItemWrapper>
          </SC.FilterWrapper>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
}
